import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { HelpCircle } from 'lucide-react';
import { ContactModal } from './ContactModal';
import { useTranslation } from 'react-i18next';
import { useSettings } from '@/contexts/SettingsContext';
import { coverUrl } from '@/utils/coverImage';

export const Footer = () => {
  const { t } = useTranslation();
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const { settings } = useSettings();
  const currentYear = new Date().getFullYear();

  return (
    <>
      <footer className="bg-surface-container-low mt-auto">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex items-center space-x-2">
              <img 
                src={coverUrl(settings.logo_url, 'logo') || settings.logo_url || "/lovable-uploads/61dab0b5-7f0c-46f5-9cb9-feeb93237e94.png"} 
                alt={settings.site_name || "Equiphoto.ch"} 
                className="h-6"
              />
              <span className="text-sm text-muted-foreground font-serif">
                © {currentYear} {settings.site_name || "Equiphoto.ch"}. {t('footer.allRightsReserved')}
              </span>
            </div>
            
            <Button
              variant="secondary"
              size="sm"
              onClick={() => setIsContactModalOpen(true)}
              className="flex items-center space-x-2"
            >
              <HelpCircle className="w-4 h-4" />
              <span>{t('contact.contactUs')}</span>
            </Button>
          </div>
        </div>
      </footer>
      
      <ContactModal 
        isOpen={isContactModalOpen} 
        onClose={() => setIsContactModalOpen(false)} 
      />
    </>
  );
};
